import axios from "axios"
import constants from "../../../constants"

export const getWaterlineTestCompliance = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-test-compliance`)
  const waterlineTestCompliance = response.data

  return waterlineTestCompliance
}

export const getWaterlineItemCompliance = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/waterline-item-compliance`)
  const waterlineItemCompliance = response.data

  return waterlineItemCompliance
}
